import '@vuepic/vue-datepicker/dist/main.css'
import { createLogto, type LogtoConfig, UserScope } from '@logto/vue'
import VueDatePicker from '@vuepic/vue-datepicker'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import Default from './layouts/default/Default.vue'
import posthogPlugin from './plugins/posthog'
import pusherPlugin from './plugins/pusherPlugin'
import SentryPlugin from './plugins/sentry'
import { router } from './routes'

const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
})

const app = createApp(App)

const config: LogtoConfig = {
  endpoint: import.meta.env.VITE_AUTH_ENDPOINT,
  appId: import.meta.env.VITE_AUTH_TOKEN,
  scopes: [
    UserScope.Email,
    UserScope.Phone,
    UserScope.CustomData,
    UserScope.Identities,
    UserScope.Organizations,
    UserScope.Profile,
    UserScope.Roles,
    UserScope.OrganizationRoles,
  ],
  resources: [import.meta.env.VITE_AUTH_TICKETS_RESOURCE],
}
const store = createPinia()

app.component('LayoutDefault', Default)
app.use(store)
app.use(router)
app.component('VueDatePicker', VueDatePicker)
app.use(createLogto, config)
app.use(pusherPlugin)
app.use(i18n)

app.use(posthogPlugin)
app.use(SentryPlugin, { router, store })

app.mount('#app')
